import * as React from 'react';
import './App.css';
import { Switch, Route } from 'react-router-dom';
import NavMenu from './components/NavMenu';
// import CommandList from './components/CommandList';
// import Home from './components/home/Home';
// import Invite from './components/Invite';
import Suggest from './components/sug/Suggest';
import Endpoints from 'endpoints';
import { plainToClass } from 'class-transformer';
// const MINER_URL = process.env.NODE_ENV === 'development'
//   ? 'localhost'
//   : '.nadeko.bot';

export enum Caste {
  Pleb,
  Mod,
  Admin
}

export class User {
  name: string = "";
  id: string = "";
  avatar: string = "";
  caste: Caste = Caste.Pleb;
  isBanned: boolean = false;
}

export interface Suggestion {
  title: string;
  author: User;
}

export interface State {
  user: User | null;
}

class App extends React.Component<{}, State> {

  constructor(props: {}) {
    super(props);
    this.state = {
      user: null
    };

    const [ep, method] = Endpoints.USER_GET();
    fetch(ep, {
      method
    })
      .then(async (x) => {
        if (!x.ok) {
          throw new Error(x.statusText);
        }
        const data = await x.json();
        const user = data == null
          ? null
          : plainToClass(User, data);

        this.setState({
          user: user
        });
      })
      .catch((err) => console.log(err));
  }

  onLogout() {
    this.setState({ user: null });
  }

  render() {
    return [
      <NavMenu key="nav-menu" user={this.state.user} />,
      <div key="wrapper" className="wrapper-main">
        <Switch>
          <Route
            exact={true}
            path="/:sId?"
            render={(props) => (<Suggest {...props} user={this.state.user} />)} />
        </Switch>
      </div>,
      <this.renderFooter key="footer" />];
  }

  renderFooter: React.FC = () => {
    return null;
    // return (
    //   <footer>
    //     <div className="container">
    //       <div className="copyright">
    //         <p>&copy; Copyright 2019 Kwoth </p>
    //       </div>
    //     </div>
    //   </footer>
    // );
  }
}

export default App;
